let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7MbJW")).then(() => parcelRequire('4bg9b'));